import React, { Component } from 'react';
import { filterAllergensByCountry } from '../../../server/constants';
import { event } from 'react-ga';

const styles = {
    fullWidth: {
        width: "100%"
    },
    btnStyle: {
        borderRadius: "25px",
        width: "100%",
        margin: "8px 0px"
    },
    imageStyle: {
        height: '30px',
        width: '30px',
    },
    eggImageStyle: {
        height: '30px',
        width: '20px',
    },
    fishImageStyle: {
        height: '23px',
        width: '30px',
    },
    fishStyle: {

        display: "flex", alignItems: "center", padding: '9px 6px', borderRadius: "50%", border: "none !important"
    },
    allergensButtonStyle: {
        display: "flex", alignItems: "center", padding: '5px 5px', borderRadius: "50%", border: "none !important"
    },
    eggButtonStyle: {
        display: "flex", alignItems: "center", padding: '5px 9px', borderRadius: "50%", border: "none !important"
    },
    itemStyle: {
        display: "flex",
        flexDirection: "column",
        margin: "0px",
        padding: "0px",
        alignItems: "center",
    }
}
var allergiesObj = [];
class AllergiensForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allergensList: [],
            otherList: ''
        }
    }
    formatAllergiensObj = () => {
        const { selectedAllergies, stud, studentCountryCode } = this.props;
        //let countryCode = JSON.parse(sessionStorage.getItem('countryCode'))[stud.mealSchoolId];
        allergiesObj = filterAllergensByCountry(studentCountryCode);
        const selectedData = (selectedAllergies || '').split(',').filter(itm => {
            return ((itm || '').trim()).length > 0;
        });
        const allergiesObjList = Object.keys(allergiesObj).map((itm, i) => {
            return allergiesObj[itm].display;
        });
        const unchosen = selectedData.filter((itm) => {
            return allergiesObjList.indexOf(itm) == -1;
        });
        const chosen = selectedData.filter((itm) => {
            return allergiesObjList.indexOf(itm) != -1;
        });
        this.setState({
            allergensList: chosen,
            otherList: unchosen.join(',')
        });

    }
    componentDidMount = () => {
        this.formatAllergiensObj();
    }
    onAllergensChange = (item, id) => {
        const _allergensList = [...this.state.allergensList];
        // console.log("_allergensList ::::: ",_allergensList);
        const idx = _allergensList.findIndex(itm => {
            return item === itm;
        });
        if (idx > -1) {
            _allergensList.splice(idx, 1);
        } else {
            _allergensList.push(item);
        }
        this.setState({ allergensList: _allergensList }, () => {
            let list = (this.state.allergensList.join(',') + ',' + this.state.otherList).split(',').map(itm => {
                return ((itm || '').trim());
            });
            list = list.filter((e, i, self) => i === self.indexOf(e))
            this.props.onChangeAllergens(list.join(','));
        })
    }
    handleAllergensTextChange = (event) => {
        this.setState({
            otherList: event.target.value
        });
    }
    handleAllergensOnBlur = () => {
        let list = (this.state.allergensList.join(',') + ',' + this.state.otherList).split(',').map(itm => {
            return ((itm || '').trim());
        });
        list = list.filter((e, i, self) => i === self.indexOf(e))
        this.props.onChangeAllergens(list.join(','));
    }

    render() {
        const { selectedAllergies, stud, AllergyRecSubmit } = this.props;

        return (
            <div>
                <div className='row'>
                    <div className="col-md-12">
                        <h4 className="sub-title text-danger" style={{ marginBottom: '10px' }} ><label>{'Allergies'}</label></h4>
                    </div>
                    {
                        Object.keys(allergiesObj).map((itm, i) => {
                            const allergies = (this.state.allergensList || [])
                            return (<div className="mb-4  col-xs-4  col-sm-3 col-md-2" style={{ display: "inline-block", textAlign: "center", marginBottom: "8px", float: "none" }}>
                                <div className="mb-6  col-xs-12  col-sm-12 col-md-12" style={styles.itemStyle}>
                                    <button type='button' onClick={(e) => {
                                        e.preventDefault()
                                        this.onAllergensChange(allergiesObj[itm].display, stud.id)
                                    }} className={`${(allergies.includes(allergiesObj[itm].display)) ? 'btn-primary' : 'btn-allergens'}`}
                                        style={itm !== 'fish' ? (itm !== 'eggs' ? styles.allergensButtonStyle : styles.eggButtonStyle) : styles.fishStyle}>
                                        <img src={allergiesObj[itm].image} className="img-fluid" alt="..." style={itm !== 'fish' ? (itm !== 'eggs' ? styles.imageStyle : styles.eggImageStyle) : styles.fishImageStyle} />
                                    </button>
                                    <span className="" style={{
                                        //width: '65%',
                                        background: 'transparent',
                                        border: '0',
                                        fontSize: '13px',
                                        fontWeight: 'bold'
                                    }}>{allergiesObj[itm].display}</span>
                                </div>
                            </div>)
                        })

                    }

                </div>
                <div className='row'>
                    <div className="col-md-12">
                        <form id={"showAllergy" + stud.id} name={"showAllergy" + stud.id} >
                            <div>
                                <h4 className="sub-title text-danger" style={{ marginBottom: '10px' }} >{'Other Allergies'}</h4>
                                <textarea id={"txtAllergies" + stud.id} name="comment"
                                    style={styles.fullWidth}
                                    className="form-control allergies-textarea"
                                    placeholder="Enter allergies..."
                                    onChange={(e) => this.handleAllergensTextChange(e)}
                                    value={this.state.otherList} onBlur={this.handleAllergensOnBlur}
                                ></textarea>
                            </div>
                            {/* <div className='row mt-2' >

                                <div className="col-md-6">
                                    <input type="button" style={styles.btnStyle} className="allergies-success" value={(stud.allergies == undefined ? '' : stud.allergies) == '' ? "Save" : "Update"}
                                        onClick={() => {
                                            const { allergensList, otherList } = this.state;
                                            let allergiesString = '';
                                            let allList = [];
                                            if (allergensList.length > 0) {
                                                allList = [...allergensList];
                                            }
                                            if ((otherList.trim()).length > 0) {
                                                allList = [...allList, ...this.state.otherList.split(',')];
                                            }
                                            AllergyRecSubmit(allList.join(','), stud.id)
                                        }} />
                                </div>
                            </div> */}
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default AllergiensForm;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/SetUpSchool/allergiensForm.jsx